import type { AbiItem } from 'web3-utils';

import crowdsale from './crowdsale.abi.json';
import erc20 from './erc20.abi.json';

export * from './crowdsaleAbi';
export * from './erc20Abi';
export * from './tap2mine.abi';
export * from './tap2mineReferral.abi';

export const crowdsaleAbi = crowdsale as AbiItem[];
export const erc20Abi = erc20 as AbiItem[];
